module.exports = __webpack_public_path__ + "img/27.c5f0265.jpg";